import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Search, PlusCircle, MapPin, ArrowRight } from 'lucide-react';

export function InPostCTA() {
  const navigate = useNavigate();
  const [location, setLocation] = useState('');

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    if (location.trim()) {
      navigate(`/search?city=${encodeURIComponent(location)}`);
    } else {
      navigate('/search');
    }
  };

  return (
    <div className="my-12 not-prose">
      <div className="bg-slate-900 rounded-2xl overflow-hidden shadow-xl border border-slate-800 relative">
        {/* Decorative gradients */}
        <div className="absolute top-0 right-0 w-64 h-64 bg-blue-600/20 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2 pointer-events-none"></div>
        <div className="absolute bottom-0 left-0 w-64 h-64 bg-purple-600/20 rounded-full blur-3xl translate-y-1/2 -translate-x-1/2 pointer-events-none"></div>

        <div className="relative z-10 p-6 md:p-8 grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
          
          {/* Lado Izquierdo: Buscador */}
          <div className="space-y-4">
            <h3 className="text-xl font-bold text-white leading-tight">
              ¿Buscas un trastero en tu zona?
            </h3>
            <p className="text-slate-400 text-sm">
              Encuentra espacios verificados cerca de ti al mejor precio.
            </p>
            
            <form onSubmit={handleSearch} className="relative">
              <div className="relative flex items-center">
                <MapPin className="absolute left-3 text-slate-400 w-5 h-5" />
                <input 
                  type="text" 
                  placeholder="Ej: Madrid, Valencia..." 
                  className="w-full bg-slate-800 text-white pl-10 pr-12 py-3 rounded-xl border border-slate-700 focus:ring-2 focus:ring-blue-500 outline-none placeholder:text-slate-500 transition-all"
                  value={location}
                  onChange={(e) => setLocation(e.target.value)}
                />
                <button 
                  type="submit"
                  className="absolute right-1.5 bg-blue-600 hover:bg-blue-500 text-white p-1.5 rounded-lg transition-colors"
                >
                  <Search className="w-5 h-5" />
                </button>
              </div>
            </form>
          </div>

          {/* Separador Móvil / Desktop */}
          <div className="hidden md:block w-px h-24 bg-slate-700 mx-auto"></div>
          <div className="md:hidden w-full h-px bg-slate-700"></div>

          {/* Lado Derecho: Publicar */}
          <div className="space-y-4 text-center md:text-left">
            <h3 className="text-xl font-bold text-white leading-tight">
              ¿Tienes espacio libre?
            </h3>
            <p className="text-slate-400 text-sm">
              Alquila tu trastero gratis y gana dinero extra cada mes.
            </p>
            <button 
              onClick={() => navigate('/publish')}
              className="w-full bg-white text-slate-900 font-bold py-3 px-6 rounded-xl hover:bg-blue-50 transition-colors flex items-center justify-center gap-2 shadow-lg shadow-white/10"
            >
              <PlusCircle className="w-5 h-5 text-blue-600" />
              Publicar Gratis
              <ArrowRight className="w-4 h-4 ml-auto opacity-50" />
            </button>
          </div>

        </div>
      </div>
    </div>
  );
}
